/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CreateCommentMutation_story$ref } from "./CreateCommentMutation_story.graphql";
import { CreateCommentReplyMutation_story$ref } from "./CreateCommentReplyMutation_story.graphql";
import { PostCommentFormContainer_story$ref } from "./PostCommentFormContainer_story.graphql";
import { StoryClosedTimeoutContainer_story$ref } from "./StoryClosedTimeoutContainer_story.graphql";
export type STORY_MODE = "COMMENTS" | "QA" | "%future added value";
declare const _StreamContainer_story$ref: unique symbol;
export type StreamContainer_story$ref = typeof _StreamContainer_story$ref;
export type StreamContainer_story = {
    readonly id: string;
    readonly url: string;
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly commentCounts: {
        readonly totalPublished: number;
        readonly tags: {
            readonly FEATURED: number;
            readonly UNANSWERED: number;
        };
    };
    readonly " $fragmentRefs": PostCommentFormContainer_story$ref & StoryClosedTimeoutContainer_story$ref & CreateCommentReplyMutation_story$ref & CreateCommentMutation_story$ref;
    readonly " $refType": StreamContainer_story$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StreamContainer_story",
    "type": "Story",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "settings",
            "storageKey": null,
            "args": null,
            "concreteType": "StorySettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "mode",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "commentCounts",
            "storageKey": null,
            "args": null,
            "concreteType": "CommentCounts",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalPublished",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tags",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CommentTagCounts",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "FEATURED",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "UNANSWERED",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PostCommentFormContainer_story",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "StoryClosedTimeoutContainer_story",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CreateCommentReplyMutation_story",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CreateCommentMutation_story",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'f31190fe8024b360c340b6fcd54cdd41';
export default node;
